export const FETCH_PERSON_VEHICLES_END = "setPersonVehiclesList";
export const LOAD_PERSON_VEHICLE_TO_EDIT = "loadPersonVehcileToEdit";
export const RESET_DEFAULT_NEW_PERSON_VEHICLE = "resetdefaultnewpersonvehicle";
export const RESET_DEFAULT_PERSON_VEHICLE_TO_EDIT = "resetdefaultpersonvehicletoedit";
export const RESET_DEFAULT_VEHICLE_TO_EDIT = "resultDefaultVehicleToEdit";
export const TOGGLE_EDIT_PERSON_VEHICLE_DIALOG = "toggleEditPersonVehicleDialog";
export const TOGGLE_NEW_PERSON_VEHICLE_DIALOG = "toggleNewPersonVehicleDialog";
export const TOGGLE_PERSON_VEHICLE_EDIT_STATE = "togglePersonVehicleEditState";
export const UPDATE_ADD_PERSON_VEHICLE_FIELD = "updateAddPersonHolidayEntitlementField";
export const UPDATE_EDIT_PERSON_VEHICLE_FIELD = "updateEditPersonHolidayEntitlementField";
export const UPDATE_NEW_PERSON_VEHICLE = "updateNewPersonVehicle";
export const UPDATE_PERSON_VEHICLE_FIELD = "updatePersonVehicleField";
